import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: ModalHelper UI Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.modal-helper.';

  public static readonly elementNotModal = `${Id.prefix}elementNotModal`;
}

export class LangModalHelper {
  private constructor() {}
  public static elementNotModal(): string {
    return interpolate(Id.elementNotModal);
  }
}

export class ModalHelperModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // ModalHelper UI Strings
    register.add(
      Id.elementNotModal,
      'Element provided does not contain a modal dialog',
      'Error message when an element is not a modal dialog'
    );
  }
}
